import { Component, OnInit, ViewChild,AfterViewInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { Router } from '@angular/router';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';

@Component({
  selector: 'app-avt-liste-matiere',
  templateUrl: './avt-liste-matiere.component.html',
  styleUrls: ['./avt-liste-matiere.component.scss']
})
export class AvtListeMatiereComponent implements OnInit
{
  
  constructor(public generalService : GeneralService,public router : Router) { }
  exist :boolean = false;
  @ViewChild("listeMatiereComponen",{static : false}) listeMatiereComponen : AvtListesComponent;
  columns = 
  {
    "TableRD":
    [
      {"TableRE_Code":"","TableRD_Champs":"DiverSys_Index","Lg_Code":"","TableRD_Des":"Code","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
      {"TableRE_Code":"","TableRD_Champs":"DiverSys_Titre","Lg_Code":"","TableRD_Des":"Libellé","TableRD_Largeur":300,"TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}
    ]
  }
  listBtn:Array<any> = 
  [
    {name:"ajouter",class:"colorGreen",text:"Ajouter",disabled : false,icon:"add"},
    {name:"modifier",class:"colorBlue",text:"Modifier",disabled : false,icon:"edite"},
    {name:"delete",class:"colorRed",text:"Supprimer",disabled : false,icon:"delete"}
  ]
  dsMatier;
  ngOnInit() 
  {
    this.getListeMatier();
  }
  getListeMatier()
  {
    this.generalService.rechercheTable("ds/formdata?code=DiverSys&val=MAT01").subscribe(data =>
    {
      this.dsMatier = data;
      this.listeMatiereComponen.setDataSource(data.DiverSys);
      this.exist = true;
      this.listeMatiereComponen.rows = [];
    });
  }
  clickBtnHeat(event)
  {
    switch (event.name)
    {
      case "ajouter":
      {
        this.router.navigate(["avt/matiere"])
        break;
      }
      case "modifier":
      {
        this.modifier()
        break;
      }
      case "delete":
      {
        
        this.supprimer()
        break;
      }
    }
  }
  modifier()
  {
    if(this.generalService.isNotEmpty(this.dsMatier))
    {
      this.exist = false;
      this.listBtn[0].disabled = true;
      this.listBtn[1].disabled = true;
      this.listBtn[2].disabled = true;
      this.generalService.enregisterTable(this.dsMatier).subscribe(data => 
      {
        this.listBtn[0].disabled = false;
        this.listBtn[1].disabled = false;
        this.listBtn[2].disabled = false;
        this.exist = true;
        this.dsMatier = null
        this.getListeMatier();
        this.generalService.dialogSuccess("Enregister", true)
      },
      ()=>
      {
        this.listBtn[0].disabled = false;
        this.listBtn[1].disabled = false;
        this.listBtn[2].disabled = false;
        this.exist = true;
        this.generalService.dialogSuccess("Non enregister", false)
      })
    }
    else
      this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données", true)
  }
  supprimer()
  {
    if(this.listeMatiereComponen.rows != undefined && this.listeMatiereComponen.rows.length > 0)
    {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          this.exist = false;
          this.listBtn[1].disabled = true;
          var compte = this.listeMatiereComponen.rows.length;
          this.listeMatiereComponen.rows.forEach(row => 
          {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(row.DiverSys_Id,"DiverSysSup");
            if(deleteFn != null)
            {              
              deleteFn.subscribe(data => 
              {   
                compte--;
                if(compte == 0)
                {
                  this.exist = true;
                  this.getListeMatier();
                  this.listBtn[1].disabled = false;
                }           
                this.generalService.dialogSuccess("Elément supprimer",true);
              },
              error =>
              {
                  this.generalService.dialogSuccess("Elément non supprimé",false);
                  this.exist = true;
                  this.listBtn[1].disabled = false;
              });
            }
          });
          
        }
        if(result == "annuler")
        {
        }
      });
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une ou plusieurs lignes",false)

  }
}
